var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cv-button',{attrs:{"icon":_vm.Rotate24,"kind":"ghost"},on:{"click":function($event){return _vm.onClick()}}},[_vm._v(" Start over ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }